import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../../Button';
import { CARD_ELEMENT_TYPE } from '../../../../../../../../../services/cards/constants';
import { isElementCardBackground } from '../../../CardDesignerBackgroundControls/helpers';
import DragIcon from '../../../../../../../../icons/DragIcon';
import { isElementCardForeground } from '../../../CardDesignerForegroundControls/helpers';

const propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    cardElement: PropTypes.shape({
      type: PropTypes.oneOf(Object.values(CARD_ELEMENT_TYPE)),
    }),
  }),
  isSelected: PropTypes.bool,
  isDraggable: PropTypes.bool,
};

const CardDesignerLayer = ({
  element,
  onClick,
  isSelected,
  isDraggable,
  isDragging,
}) => {
  const { cardElement, cardElementConfiguration } = element;
  const label = useMemo(() => {
    if (cardElement.type === CARD_ELEMENT_TYPE.TEXT) {
      return `"${
        cardElementConfiguration.text ??
        cardElementConfiguration.label ??
        cardElementConfiguration.help_placeholder ??
        'Text slot'
      }"`;
    }

    if (isElementCardBackground(element)) {
      return 'Background';
    }

    if (isElementCardForeground(element)) {
      return 'Foreground';
    }

    if (cardElement.type === CARD_ELEMENT_TYPE.PHOTO) {
      return (
        cardElementConfiguration?.asset_image?.original_filename ?? 'Photo slot'
      );
    }

    if (cardElement.type === CARD_ELEMENT_TYPE.RECTANGLE) {
      return 'Rectangle slot';
    }

    return 'Element';
  }, [cardElement, cardElementConfiguration]);

  const classes = classNames({
    'card-designer-layer': true,
    active: isSelected,
    static: !isDraggable,
    dragging: isDragging,
  });

  return (
    <Button btnStyle="reset" className={classes} onClick={onClick}>
      <div className="card-designer-layer-label">{label}</div>
      {isDraggable && (
        <DragIcon size={16} color={isSelected ? '#0d84fe' : '#b5bcbd'} />
      )}
    </Button>
  );
};

CardDesignerLayer.propTypes = propTypes;

export default CardDesignerLayer;
